import { render, staticRenderFns } from "./ReporteTurnosTif.vue?vue&type=template&id=1eb59d9d"
import script from "./ReporteTurnosTif.vue?vue&type=script&lang=js"
export * from "./ReporteTurnosTif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports